import { ToastrService, GlobalConfig } from 'ngx-toastr';
import { Injectable } from '@angular/core';

@Injectable()
export class ToastConfigService {

  private toasterService: ToastrService;

  public config: GlobalConfig;

  constructor(toasterService: ToastrService) {
    this.toasterService = toasterService;
   }

   popToast(message: string) {
    this.toasterService.success(message, 'Success', {
      closeButton: true,
      tapToDismiss: true,
      positionClass: 'toast-bottom-center',
      timeOut: 2000
    });
  }

}
